import styled from "styled-components";

export enum OrientationType {
  PointUp = "point_up",
  PointDown = "point_down",
  PointRight = "point_right",
  PointLeft = "point_left",
}

interface Props {
  orientation: string;
  height?: string;
  width?: string;
}

const StyledArrow = styled.svg<Props>`
  transform: ${(props) =>
    props.orientation === OrientationType.PointUp
      ? "rotate(90deg);"
      : props.orientation === OrientationType.PointRight
      ? "rotate(180deg);"
      : props.orientation === OrientationType.PointDown
      ? "rotate(270deg)"
      : "rotate(0deg);"};
`;

const Arrow = ({ orientation, height, width }: Props) => {
  return (
    <StyledArrow
      xmlns="http://www.w3.org/2000/svg"
      width={width || "8"}
      height={height || "13"}
      viewBox="0 0 8 13"
      orientation={orientation}
    >
      <g id="left-arrow-chevron" transform="translate(0.717 0.707)">
        <g id="Group_1948" data-name="Group 1948" transform="translate(0)">
          <path
            id="Path_1151"
            data-name="Path 1151"
            d="M6.153,11.977,0,5.971,6.153,0"
            transform="translate(0)"
            fill="none"
            stroke="#343638"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </StyledArrow>
  );
};

export default Arrow;
